import { IconButton, Stack, Badge, Popover, Box, List, ListItemButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import api from "../services/api";


export default function TipoExpedienteFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [tipoDocumento, setTipoDocumento] = useState([]);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    api.get('/expediente-docs')
      .then((res) => {
        setTipoDocumento(res.data.expedienteDocss)
      })
      .catch((err) => '')
  }, [])

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.documento}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box minWidth={200}>

          <List component="nav" aria-label="secondary mailbox folder">
            <ListItemButton
              selected={props.documento === ""}
              onClick={(event) => {
                props.setDocumento("");
                onClose();
              }}
            >
              Geral
            </ListItemButton>

            {tipoDocumento.map((documento) => (
              <ListItemButton
                key={documento?._id}
                selected={props?.documento === documento?._id}
                onClick={(event) => {
                  props.setDocumento(documento?._id);
                  onClose();
                }}
              >
                {documento?.designacao}
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Popover>
    </Stack>
  );
};


